export const featureFlagsKeys = {
  all: [{ module: 'featureFlags' }] as const,
  attorneyView: () => [{ ...featureFlagsKeys.all[0], scope: 'attorneyView' }] as const,
  asWeb: () => [{ ...featureFlagsKeys.all[0], scope: 'asWeb' }] as const,
};
